import React from 'react'

/**
 * Displays the corresponding deduction rule where items and production rules
 * can be dropped.
 */
export function TagCykEpsScan() {
    return (
        <div className='deduction-rule'>
            <div className='rule-name'>Eps-Scan:</div>
            <div className='middle-rule-part'>
                <hr/>
                <div
                    className='consequence'>[ɣ, ρ<sub>⊤</sub>, i, -, -, i]
                </div>
            </div>
            <div className='side-condition'><span className={'unbreakable'}>l(ɣ, ρ) = ε</span>
            </div>
        </div>)
}
